import { useTheme } from "@emotion/react";
import { FormControl } from "@mui/material";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import React from "react";
import ReactPhoneInput from "react-phone-input-material-ui";
import styled from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import FormLabel from "../FormLabel";
import { InputProps } from "./InputProps";
const StyledTextField = styled(TextField)`
  margin: 0px 0;
  padding: 0;
`;

export type TextInputPropsType = InputProps & TextFieldProps;

interface TextInputInputProps extends Omit<TextInputPropsType, "onChange"> {
  onChange: (value: string) => void;
  value: string | null;
}

const PhoneInput: React.FC<TextInputInputProps> = ({
  label,
  value,
  onChange,
  error,
  helperText,
  isRequired = true,
  rows = 3,
  maxRows = 10,
  type = "text",
  ...rest
}: TextInputInputProps) => {
  const theme: any = useTheme();

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl fullWidth disabled={isDisabled}>
      <FormLabel error={error}>{label}</FormLabel>
      <ReactPhoneInput
        component={StyledTextField}
        value={value}
        onChange={(phone) => onChange(phone)}
        inputClass={StyledTextField}
        inputProps={{
          variant: "outlined",
          fullWidth: true,
          label: "",
          error: error,
          helperText: error ? helperText : " ",
        }}
      />
    </FormControl>
  );
};

export default PhoneInput;
